const SIZE_RANKS = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, "2XL": 6, XXXL: 7, "3XL": 7, "4XL": 8, "5XL": 9, "6XL": 10, "7XL": 11, "8XL": 12 };

export const sizeRank = (s) => {
  const t = String(s).trim().toUpperCase().replace(/\s/g, "");
  if (t in SIZE_RANKS) return [0, SIZE_RANKS[t], ""];
  const m = t.match(/^(\d+)/);
  if (m) return [1, parseInt(m[1], 10), ""];
  return [2, 0, t];
};

const cmp = (a, b) => {
  for (let i = 0; i < 3; i++) {
    if (a[i] < b[i]) return -1;
    if (a[i] > b[i]) return 1;
  }
  return 0;
};

export const sortSizeEntries = (sizes) => Object.entries(sizes || {}).sort((a, b) => cmp(sizeRank(a[0]), sizeRank(b[0])));
export const sortSizeKeys = (keys) => [...(keys || [])].sort((a, b) => cmp(sizeRank(a), sizeRank(b)));
